<template>
  <div
    @mousedown="onMousedown"
    class="d-flex"
    :class="{ 'label-on-line': onLine }"
  >
    <div
      ref="eventNameLabel"
      class="label-name"
      :class="{ 'label-empty': isEmptyContent && !isFocused }"
      :contenteditable="!$store.state.isWorkflowDisabled && node.id == $route.params.eventId"
      @keydown.stop="checkCharacterLimit($event, characterLimit)"
      @keydown.stop.enter="$event.target.blur()"
      @keydown.stop.esc="restoreValue($event, conditionLabel || '[Label]')"
      @blur="onBlur"
      @focus="onFocus"
      @paste="onPaste($event, $refs.eventNameLabel, characterLimit, false, 12)"
      v-text="conditionLabel"
      :data-test-label-name="conditionLabel || '[Label]'"
      @input="onInput"
    ></div>
  </div>
</template>

<script>
import { diagramHelpers } from '@/mixins/diagramHelpers.js'
import { updateFontSizeDynamically } from '@/utils/update-font'

export default {
  mixins: [diagramHelpers],
  props: {
    node: Object,
    conditionLabel: String,
    characterLimit: {
      type: Number,
      default: 30
    },
    autoFocusOnSelect: {
      type: Boolean,
      default: false
    },
    onLine: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      pendingFocus: false,
      isFocused: false,
      isEmptyContent: !(this.conditionLabel && this.conditionLabel.trim())
    }
  },

  watch: {
    '$route.params.eventId' (eventId) {
      if (this.pendingFocus && eventId === this.node.id) {
        this.pendingFocus = false
        this.focusLabel()
      }
    },
    conditionLabel (value) {
      this.isEmptyContent = !(value && value.trim())
    }
  },

  methods: {
    updateFontSizeDynamically,
    onInput (ev) {
      this.isEmptyContent = !(ev.target.textContent || '').trim()
      updateFontSizeDynamically(ev.target, false, 12)
    },
    onFocus (ev) {
      this.isFocused = true
      this.$emit('label-focus', ev)
    },
    onBlur (ev) {
      this.isFocused = false
      this.$emit('label-blur', ev)
    },
    onMousedown () {
      this.$emit('label-mousedown')
      if (this.autoFocusOnSelect) {
        if (this.node.id === this.$route.params.eventId) {
          this.focusLabel()
        } else {
          this.pendingFocus = true
        }
      }
      this.changeSelectedEvent(this.node.id)
    },
    focusLabel () {
      this.$nextTick(() => {
        this.$refs.eventNameLabel?.focus()
      })
    }
  },

  mounted () {
    if (this.$refs.eventNameLabel) {
      updateFontSizeDynamically(this.$refs.eventNameLabel, false, 12)
    }
    if (this.selectNewConnection) {
      // yuriy
      // for some reason `this.$nextTick` doesn't fix the problem
      // with async state change of the component
      // `setTimeout` does a trick and allows to select the text
      // when element becomes selected
      //
      // staffan:
      // disabled because of cypress tests
      // window.setTimeout(() => {
      //   const node = this.$el.querySelector('.label-name')

      //   const selection = window.getSelection()
      //   const range = document.createRange()
      //   range.selectNodeContents(node)
      //   selection.removeAllRanges()
      //   selection.addRange(range)
      // }, 500)
    }
  }
}
</script>
<style scoped>
.label-name {
  flex-direction: column-reverse;
  padding: 4px;
  max-height: 30px !important;
  word-break: break-word;
  border-radius: 4px;
  background: var(--light-1);
  color: var(--text-dark);
  font-weight: 500;
  line-height: 12px;
}

.label-name:focus-visible {
  outline: none;
}

.label-on-line {
  height: 100%;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.label-on-line .label-name {
  pointer-events: auto;
}

.label-on-line .label-name,
.label-empty {
  border: 1px solid var(--diagram-stroke);
}

.label-empty {
  position: relative;
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  padding: 0;
  border-radius: 50%;
  line-height: 0;
  cursor: pointer;
}

.label-empty::after {
  content: '';
  position: absolute;
  inset: 0;
  background:
    linear-gradient(var(--text-dark), var(--text-dark)) center / 1px 8px no-repeat,
    linear-gradient(var(--text-dark), var(--text-dark)) center / 8px 1px no-repeat;
}
</style>
